import React from 'react';

import { LegacyIconProps } from '../icons/iconUtilities';

export const FireInfoIcon = ({ 
    width = 32, 
    height = 32, 
    color = '#FF5B00'
}: LegacyIconProps) => {
    return (
        <svg width={width} height={height} viewBox='0 0 32 32'>
            <g id='20180802' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <g id='Artboard-2' transform='translate(-25.000000, -165.000000)' fillRule='nonzero'>
                    <g id='ic_fire_dialog' transform='translate(25.000000, 165.000000)'>
                        <circle id='Oval' fill={color} cx='16' cy='16' r='16'></circle>
                        <path d='M16.0537422,26 C26.0506594,26 27.2776357,13.3333333 20.0863631,8.5241152 C20.5465117,9.5870796 20.6336846,11.3877826 19.7040475,12.2606548 C18.1299532,5.95851752 14.238304,4.66666667 14.238304,4.66666667 C14.6984526,7.91698413 12.5701875,11.4711904 10.5178874,14.1266616 C10.4456584,12.8302847 10.3696934,11.9360757 9.7246136,10.6959506 C9.57953293,13.0501192 7.8763228,14.9690785 7.41453067,17.3284861 C6.8753244,20.0834215 8.94047133,26 16.0537422,26 Z' id='Shape' fill='#FFFFFF'></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
